// src/serviceWorkerRegistration.ts

type Config = {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
};

export function register(config?: Config) {
  if ('serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      // 自動リロード処理を先に設定
      setupAutoReload();

      // 環境に関わらず同じ登録処理を実行
      registerValidSW(swUrl, config);
    });
  }
}

function registerValidSW(swUrl: string, config?: Config) {
  console.log('[PWA] Registering SW...');
  navigator.serviceWorker
    .register(swUrl, {
      updateViaCache: 'none', // Service Workerファイルをキャッシュしない
    })
    .then(registration => {
      console.log('[PWA] SW registered successfully');

      // 登録直後に待機中のWorkerがあるかチェック
      if (registration.waiting) {
        console.log('[PWA] Waiting worker found on registration');
        if (config?.onUpdate) {
          config.onUpdate(registration);
        }
        return;
      }

      // アクティブなWorkerがある場合は初回インストール完了
      if (registration.active && !navigator.serviceWorker.controller) {
        console.log('[PWA] First install complete');
        if (config?.onSuccess) {
          config.onSuccess(registration);
        }
      }

      // 更新をチェック
      registration.onupdatefound = () => {
        console.log('[PWA] Update found!');
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          console.log('[PWA] No installing worker');
          return;
        }

        installingWorker.onstatechange = () => {
          console.log('[PWA] Installing worker state:', installingWorker.state);
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // 更新あり
              console.log('[PWA] New version available');
              if (config?.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // 初回インストール
              console.log('[PWA] First install');
              if (config?.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };

      // 登録後すぐに更新をチェック
      console.log('[PWA] Checking for updates...');
      registration.update();

      // 定期的に更新をチェック（5分ごと）
      setInterval(() => {
        console.log('[PWA] Periodic update check');
        registration.update();
      }, 5 * 60 * 1000);
    })
    .catch(error => {
      console.error('[PWA] SW registration failed:', error);
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
      })
      .catch(error => {
        console.error(error.message);
      });
  }
}

// 自動リロード処理
function setupAutoReload() {
  console.log('[PWA] Setting up auto reload');
  if ('serviceWorker' in navigator) {
    let refreshing = false;

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      console.log('[PWA] Controller changed');
      if (refreshing) {
        console.log('[PWA] Already refreshing, skipping');
        return;
      }
      refreshing = true;
      console.log('[PWA] Reloading page...');
      sessionStorage.setItem('pwa-updated', 'true');
      window.location.reload();
    });

    // アプリが再び表示された時に更新をチェック
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        console.log('[PWA] App became visible, checking for updates');
        navigator.serviceWorker.getRegistration().then(registration => {
          if (registration) {
            registration.update();
          }
        });
      }
    });
  }
}
